import { List, Map } from 'immutable'
import { createSelector } from 'reselect'

export const getCustomerCountry = (state: $TSFixMe) => state.get('customerCountry', Map())

export const getCountryListForCustomerCountry = createSelector(getCustomerCountry, (customerCountry) =>
  customerCountry?.get('customerCountryList', List()),
)
